import * as React from 'react';
import styled from 'styled-components';
import { Icon } from '../../shared/Icon';

interface IProps {
  labels: Array<string | React.ReactElement>;
  shape?: number[];
  style?: React.CSSProperties;
  leftAlignLastCell?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  align-items: flex-end;
  padding-bottom: 3px;
`;

const Cell = styled.div<{ leftAlignLastCell?: boolean }>`
  display: flex;
  justify-content: flex-start;
  min-width: 0;
  overflow: hidden;
  &:first-child {
    padding-left: 12px;
  }
  &:last-child {
    justify-content: ${(props: { leftAlignLastCell?: boolean }): string =>
      props.leftAlignLastCell ? 'flex-start' : 'flex-end'};
    margin-right: ${(props: { leftAlignLastCell?: boolean }): string =>
      props.leftAlignLastCell ? '0px' : '14px'};
  }
`;

export const ListHeader = (props: IProps): React.ReactElement => {
  return (
    <Container style={props.style}>
      {props.labels.map((label: string, index: number): React.ReactElement => {
        const flex = props.shape ? props.shape[index] ?? 1 : 1;
        return (
          <Cell
            key={index}
            style={{ flex }}
            leftAlignLastCell={props.leftAlignLastCell}
          >
            {label}
          </Cell>
        );
      })}
    </Container>
  );
};
